import { Box, Flex, Image, Text } from "@chakra-ui/react";

export function RunFlatModal() {
  return (
    <Flex direction="column">
      <Image
        maxH="400px"
        w="auto"
        src="https://cdn.pneufree.com.br/CMS/images/icons/geral/09-27-2021-14-27normalxrunflat.jpg"
        alt="Run Flat"
      />
      <Box w="100%" h="60px" bg="blue.900" p="1rem" mb="1rem">
        <Text textStyle="MBold" fontSize="h1" color="yellow.900" ml="10px">
          RUN FLAT
        </Text>
      </Box>
      <Box mt="1rem" mb="16px" color="gray.500">
        <Text>
          Pneus do tipo Run Flat possuem estrutura reforçada nos flancos (laterais do pneu), nos
          ombros e talões (parte que fica em contato com a roda). Quando esse tipo de pneu perde
          pressão, parcial ou totalmente, o peso do veículo fica apoiado apenas sobre a estrutura do
          pneu, dispensando a parada imediata e sua troca, podendo rodar por 80 quilômetros a uma
          velocidade de até 80 Km/h sob essas condições, sem que se perca o controle do veículo.
        </Text>

        <Flex border="#ffc723 1px solid " mt="1rem" direction={["column", "row"]}>
          <Image
            maxW="50px"
            src="https://cdn.pneufree.com.br/CMS/images/icons/geral/01-29-2020-21-30alert.png"
            alt="Warnning"
            m={["auto", "auto 15px"]}
          />
          <Text m="1rem 1rem" fontSize={["text3", "text1"]}>
            Esse tipo de pneu não pode ser aplicado em qualquer veículo. Apenas veículos que já vêm
            de fábrica com pneus Run Flat podem usá-los.
          </Text>
        </Flex>
        <Flex border="#ffc723 1px solid " mt="1rem" direction={["column", "row"]}>
          <Image
            maxW="50px"
            src="https://cdn.pneufree.com.br/CMS/images/icons/geral/01-29-2020-21-30alert.png"
            alt="Warnning"
            m={["auto", "auto 15px"]}
          />
          <Text m="1rem 1rem" fontSize={["text3", "text1"]}>
            Uma vez usados sem ar pressurizado os pneus Run Flat precisarão ser substituídos - não
            basta apenas repará-los ou inflá-los novamente.
          </Text>
        </Flex>
      </Box>
    </Flex>
  );
}
